import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';

@Component({
    selector: 'page-modal-pv-contratos-gestao',
    templateUrl: 'modal-pv-contratos-gestao.html'
})
export class ModalPreVisualizarContratosGestaoPage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public contratosGestaoService: ContratosGestaoService,
        public alertCtrl: AlertController,
        public alertService: AlertService,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.listarDados();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    listarDados() {
        this.contratosGestaoService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    };

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        if (text != undefined) {

            let separatedByWords = text.split(" ");
            let numberOfWordsToTruncate = 10;

            return separatedByWords.length >= numberOfWordsToTruncate;
        }
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    cnpj_mask(v) {
        if(v){
            v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
            v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
            return v;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/contratos-gestao/modal-pv-contratos-gestao.ts